module.exports = __webpack_public_path__ + "assets/redpack-qn-model-bg-d26603c4.png";